<template>
  <div>
    <div>
      <div style="display:flex;gap:10px;margin-top:10px;justify-content:end">
        <b-form-group
          :label="$t('StartDate')"
        >
          <date-picker
            v-model="startDate"
            type="date"
            format="YYYY-MM-DD"
            value-type="format"
            :placeholder="$t('SelectD')"
          />
        </b-form-group>
        <b-form-group
          :label="$t('EndDate')"
        >
          <date-picker
            v-model="endDate"
            type="date"
            format="YYYY-MM-DD"
            value-type="format"
            :placeholder="$t('SelectD')"
          />
        </b-form-group>
      </div>
      <table
        class="team_table"
        style="margin-top:10px;"
      >
        <thead>
          <tr>
            <th>
              {{ $t('No') }}
            </th>
            <th>
              {{ $t('DeliveryNumber') }}
            </th>
            <th>
              {{ $t('receiverLocationName') }}
            </th>
            <th>
              {{ $t('Created') }}
            </th>
            <th>
              {{ $t('Documents') }}
            </th>
            <th>
              {{ $t('CompleteDelivery') }}
            </th>
          </tr>
        </thead>
        <LoadingSpinnerTable
          :is-loading="isRequestLoading('loadReportingDeliverys')"
          :cols="10"
          :response-data="getReportingDelivers"
        >
          <tr
            v-for="(item, index) in getReportingDelivers"
            :key="index"
            v-b-toggle.tracking-by-delivery
            v-b-tooltip.hover
            :title="$t('Click')"
            style="cursor: pointer;"
            @click="goToDetail(item)"
          >
            <td>
              {{ getReportingDeliversItems-(pageNumber-1) * pageSize-index }}.
            </td>
            <td>
              {{ item.deliveryNumber }}
            </td>
            <td>
              {{ item.receiverLocationName }}
            </td>
            <td>
              {{ formatDate(item.created) }}
            </td>
            <td>
              <button
                v-b-modal.show-edit-documents
                class="primary"
                @click.stop="showDocuments(item)"
              >
                {{ $t('Documents') }}
              </button>
            </td>
            <td>
              <button
                v-b-modal.complete-order
                class="primary"
                @click.stop="openOrder(item)"
              >
                {{ $t('CompleteDelivery') }}
              </button>
            </td>
          </tr>
        </LoadingSpinnerTable>
      </table>
      <div>
        <b-pagination
          v-if="getReportingDeliversItems > 15"
          v-model="pageNumber"
          :total-rows="getReportingDeliversItems"
          :per-page="pageSize"
          first-number
          last-number
          align="fill"
          prev-class="prev-itemi"
          next-class="next-itemi"
          class="mt-1 mb-0"
        >
          <template #prev-text>
            <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
          </template>
          <template #next-text>
            <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
          </template>
        </b-pagination>
      </div>
      <div
        v-if="isSidebarOpen"
        class="backdrop"
      />
      <TrackingByDelivery
        :location-name="locationName"
        :order-unique="orderUnique"
        :acceptance-date="acceptanceDate"
        @onCancelToggle="onCancelToggle"
      />
      <DocumentsDelivery
        :open-documents="openDocuments"
        :order-unique="orderUnique"
        @updateList="updateLists"
        @addFilesDeliveryModal="addFilesDeliveryManagement"
      />
      <CompleteDeliveryPopup
        :complete-order="completeOrder"
        @completeTheOrder="completeTheOrders"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import TrackingByDelivery from './TrackingByDelivery.vue';
import DocumentsDelivery from './modals/DocumentsDelivery.vue';
import CompleteDeliveryPopup from './modals/CompleteDeliveryPopup.vue';

export default {
  components: {
    TrackingByDelivery,
    DocumentsDelivery,
    DatePicker,
    CompleteDeliveryPopup,
  },
  props: [],
  data() {
    return {
      completeOrder: null,
      pageNumber: 1,
      pageSize: 15,
      isSidebarOpen: false,
      locationName: null,
      orderUnique: null,
      acceptanceDate: null,
      openDocuments: [],
      startDate: null,
      endDate: null,
    };
  },
  computed: {
    ...mapGetters([
      'getReportingDelivers',
      'getReportingDeliversItems',
    ]),
  },
  watch: {
    pageNumber(value) {
      if (value) {
        this.loadReportingDeliverys({
          startFilterCreated: this.startDate,
          endFilterCreated: this.endDate,
          pageNumber: value,
          pageSize: this.pageSize,
        });
        this.$emit('updatePageNumberDelivery', value)
      }
    },
    startDate(value) {
      this.pageNumber = 1
      this.loadReportingDeliverys({
        startFilterCreated: value,
        endFilterCreated: this.endDate,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      });
      this.$emit('updateStartDateDelivery', value)
    },
    endDate(value) {
      this.pageNumber = 1
      this.loadReportingDeliverys({
        startFilterCreated: this.startDate,
        endFilterCreated: value,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      });
      this.$emit('updateEndDateDelivery', value)
    },
  },
  mounted() {
    this.loadReportingDeliverys({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
    })
  },
  methods: {
    ...mapActions([
      'loadReportingDeliverys',
      'loadTrackingByOrderArticle',
      'loadDeliveryMinimalInfos',
      'addFilesDelivery',
      'completeDelivery',
    ]),
    completeTheOrders(value) {
      this.completeDelivery({
        object: null,
        deliveryManagementId: value,
        successCallback: () => {
          this.loadReportingDeliverys({
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          });
        },
      })
    },
    openOrder(value) {
      this.completeOrder = value
    },
    updateLists() {
      this.loadReportingDeliverys({
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      });
    },
    addFilesDeliveryManagement(value) {
      this.addFilesDelivery({
        object: value,
        successCallback: () => {
          this.loadReportingDeliverys({
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          });
        },
      })
    },
    showDocuments(value) {
      this.openDocuments = value.fileDatas
      this.orderUnique = {
        id: value.deliveryManagementId,
        orderNumber: value.deliveryNumber,
      }
    },
    goToDetail(item) {
      this.isSidebarOpen = true
      this.loadDeliveryMinimalInfos({
        pageNumber: 1,
        pageSize: this.pageSize,
        deliveryManagementId: item.deliveryManagementId,
      })
      this.locationName = {
        locationName: item.receiverLocationName,
        locationId: item.receiverLocationId,
      }
      this.orderUnique = {
        id: item.deliveryManagementId,
        orderNumber: item.deliveryNumber,
      }
      this.acceptanceDate = moment(item.created).format('DD.MM.YYYY')
    },
    onCancelToggle() {
      this.isSidebarOpen = false
      this.loadReportingDeliverys({
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      });
    },

    formatDate(value) {
      return value ? moment(value).format('DD.MM.YYYY') : this.$t('NoDate');
    },
  },
};
</script>

        <style scoped lang="scss">
          .team_table td {
            padding: 16px 9px !important;
          }
          .dropdrop {
            display: inline-block;
            overflow: auto;
            position: absolute;
            background: white;
            width: 227px;
            box-shadow: none;
            z-index:3;
          }

          input[name="search-box"] {
              display: block;
              max-width: 500px;
              width: 95%;
              padding: 0.5rem 1rem;
              padding-left: 25px;
          }
          .search-item {
              padding: 5px;
              max-width: 500px;
              width: 100%;
              font-weight: 400;
              color: #82868c;
              font-size: 1rem;
              border-bottom: 1px solid #e8e8e8;
          }
          .active2 {
            font-weight: bold;
            color: $base-color;
          }
          </style>
